<h2 mat-dialog-title style="text-align: center">Enter Password</h2>
<div style="text-align: center">Please enter password below</div>
<form [formGroup]="passwordFormGroup" (ngSubmit)="submitDialog()" style="text-align: center">
    <mat-form-field>
        <input matInput type="password" placeholder="Password" formControlName="password" />
        @if (passwordFormGroup.controls["password"].hasError("required")) {
            <mat-error>{{ "GENERAL.required" | translate }}</mat-error>
        }
        @if (passwordFormGroup.controls["password"].hasError("invalid")) {
            <mat-error>{{ "PROFILE.UPDATE.wrongPasswordError" | translate }}</mat-error>
        }
    </mat-form-field>
    <mat-dialog-actions style="justify-content: space-between" class="p-2">
        <button mat-raised-button color="warn" style="width: 100px" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
        <button mat-raised-button color="primary" style="width: 100px" type="submit">Confirm</button>
    </mat-dialog-actions>
</form>
